var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
let StatusCard = class StatusCard extends Vue {
    changeToStatus(status, isDefault = false) {
        if (this.disabled) {
            return;
        }
        this.$emit('statusChanged', status, isDefault);
    }
    get statusesNames() {
        return Object.keys(this.statuses);
    }
    get defaultExists() {
        return Object.keys(this.statuses).some((status) => status === this.defaultStatus);
    }
};
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], StatusCard.prototype, "statuses", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], StatusCard.prototype, "defaultStatus", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], StatusCard.prototype, "disabled", void 0);
StatusCard = __decorate([
    Component({})
], StatusCard);
export default StatusCard;
